import { WebPlugin } from '@capacitor/core';
import { CompassAccuracy } from './definitions';
export class CapgoCompassWeb extends WebPlugin {
    async getCurrentHeading() {
        throw this.unavailable('Compass not available on web');
    }
    async getPluginVersion() {
        return { version: 'web' };
    }
    async startListening() {
        throw this.unavailable('Compass not available on web');
    }
    async stopListening() {
        throw this.unavailable('Compass not available on web');
    }
    async addListener(_eventName, _listenerFunc) {
        /* eslint-enable @typescript-eslint/no-unused-vars */
        throw this.unavailable('Compass not available on web');
    }
    async checkPermissions() {
        return { compass: 'denied' };
    }
    async requestPermissions() {
        throw this.unavailable('Compass not available on web');
    }
    /* eslint-disable @typescript-eslint/no-unused-vars */
    async watchAccuracy() {
        /* eslint-enable @typescript-eslint/no-unused-vars */
        // No-op on web - accuracy monitoring not available
    }
    async unwatchAccuracy() {
        // No-op on web - accuracy monitoring not available
    }
    async getAccuracy() {
        return { accuracy: CompassAccuracy.UNKNOWN };
    }
}
//# sourceMappingURL=web.js.map